"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var parser_1 = require("../parser/parser");
var evaluationErrors_1 = require("./evaluationErrors");
/**
 * A simple implementation of the {@link EvaluationContext} interface that allows variables and functions to be registered.
 */
var SimpleEvaluationContext = /** @class */ (function () {
    function SimpleEvaluationContext() {
        this.variableMap = {};
        this.functionMap = {};
    }
    /**
     * {@inheritDoc StaticAnalysisContext.hasFunction}
     */
    SimpleEvaluationContext.prototype.hasFunction = function (name) {
        return this.functionMap.hasOwnProperty(name.toLowerCase());
    };
    /**
     * Register a new function that this evaluator can use when evaluating expressions.
     *
     * @param name The name of the function (case-insensitive).
     * @param optionsOrFunction A JS function that receives an array of {@link Value} objects for the parameters or an
     *                          object representing the function configuration. If a JS function is passed directly,
     *                          the default options for a {@link ValueFunctionDefinition} are used.
     * @throws {@link Error} if a function with the given name has already been registered.
     *                       To replace an already-registered function, first {@link unregisterFunction unregister} it
     *                       and then re-register the new implementation.
     */
    SimpleEvaluationContext.prototype.registerFunction = function (name, optionsOrFunction) {
        var lowercase = name.toLowerCase();
        if (parser_1.Parser.isReserved(lowercase)) {
            throw new evaluationErrors_1.ReservedKeywordError("Cannot register function named with reserved keyword '" + lowercase + "'");
        }
        else if (this.functionMap.hasOwnProperty(lowercase)) {
            throw new Error("Function named '" + lowercase + "' is already registered.");
        }
        if (typeof optionsOrFunction === "function") {
            var def = {
                invokeWithASTParameters: false,
                invoke: optionsOrFunction,
            };
            this.functionMap[lowercase] = def;
        }
        else {
            this.functionMap[lowercase] = optionsOrFunction;
        }
    };
    /**
     * Unregisters the function with the given name, if it exists.
     *
     * @param name The name of the function to unregister (case-insensitive).
     */
    SimpleEvaluationContext.prototype.unregisterFunction = function (name) {
        var lowercase = name.toLowerCase();
        if (this.functionMap.hasOwnProperty(lowercase)) {
            delete this.functionMap[lowercase];
        }
    };
    /**
     * {@inheritDoc TypeCheckingContext.lookupFunction}
     */
    SimpleEvaluationContext.prototype.lookupFunction = function (name) {
        var lowercase = name.toLowerCase();
        if (parser_1.Parser.isReserved(lowercase)) {
            throw new evaluationErrors_1.ReservedKeywordError("Cannot lookup function for reserved keyword '" + lowercase + "'");
        }
        else if (!this.functionMap.hasOwnProperty(lowercase)) {
            throw new evaluationErrors_1.NameError();
        }
        return this.functionMap[lowercase];
    };
    /**
     * {@inheritDoc TypeCheckingContext.hasVariable}
     */
    SimpleEvaluationContext.prototype.hasVariable = function (name) {
        return this.variableMap.hasOwnProperty(name.toLowerCase());
    };
    /**
     * Sets the variable with the given name, possibly overwriting it.
     *
     * @param name The name of the variable to set (case-insensitive).
     * @param value The new value of the variable.
     */
    SimpleEvaluationContext.prototype.setVariable = function (name, value) {
        var lowercase = name.toLowerCase();
        if (parser_1.Parser.isReserved(lowercase)) {
            throw new evaluationErrors_1.ReservedKeywordError("Cannot set variable named with reserved keyword '" + lowercase + "'");
        }
        this.variableMap[lowercase] = value;
    };
    /**
     * {@inheritDoc EvaluationContext.getVariable}
     */
    SimpleEvaluationContext.prototype.getVariable = function (name) {
        var lowercase = name.toLowerCase();
        if (parser_1.Parser.isReserved(lowercase)) {
            throw new evaluationErrors_1.ReservedKeywordError("Cannot lookup variable with reserved keyword '" + lowercase + "'");
        }
        else if (!this.variableMap.hasOwnProperty(lowercase)) {
            throw new evaluationErrors_1.NameError();
        }
        return this.variableMap[lowercase];
    };
    /**
     * {@inheritDoc TypeCheckingContext.getVariableType}
     */
    SimpleEvaluationContext.prototype.getVariableType = function (name) {
        return this.getVariable(name).type;
    };
    return SimpleEvaluationContext;
}());
exports.default = SimpleEvaluationContext;
//# sourceMappingURL=simpleEvaluationContext.js.map